module.exports = __webpack_public_path__ + "static/media/Qualify your lead.7a78501b.svg";